export default function PersonalInfo() {
  return (
    <div>
      <h3>
        Personal Information
      </h3>
      If you no longer wish to have your personal information stored, please contact meand we will delete your information.
    </div>)
}